// Verificação de suporte a navegador e carregamento de polyfills adicionais
const checkBrowserSupport = () => {
  const isOldBrowser = !window.fetch || 
                      !window.Promise || 
                      !Array.prototype.includes ||
                      !Object.entries ||
                      !window.IntersectionObserver;

  if (isOldBrowser) {
    console.warn('Navegador antigo detectado. Carregando polyfills adicionais...');
  }

  // Verificar funcionalidades básicas necessárias
  try {
    // Teste de compatibilidade ES6+ básica
    const testArrow = () => true;
    const testVar = 'test';
    let testVar2 = 'test';
    const testTemplateString = `template ${testVar}`;
    
    // Verificar se as funcionalidades básicas funcionam
    if (testArrow() && testVar && testVar2 && testTemplateString) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Erro de compatibilidade do navegador:', error);
    return false;
  }
};

// Mostrar mensagem de erro se o navegador não for suportado
const showUnsupportedBrowserMessage = () => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: center; 
        height: 100vh; 
        font-family: Arial, sans-serif; 
        text-align: center; 
        padding: 20px;
        background-color: #f5f5f5;
      ">
        <h1 style="color: #d32f2f; margin-bottom: 20px;">Navegador Não Suportado</h1>
        <p style="color: #666; max-width: 500px; line-height: 1.5;">
          Seu navegador não suporta todas as funcionalidades necessárias para executar o Reino Play. 
          Para a melhor experiência, recomendamos atualizar para uma versão mais recente do seu navegador.
        </p>
        <div style="margin-top: 20px;">
          <p style="color: #333; font-weight: bold;">Navegadores recomendados:</p>
          <ul style="list-style: none; padding: 0; color: #666;">
            <li>Chrome 70+</li>
            <li>Firefox 62+</li>
            <li>Safari 12+</li>
            <li>Edge 79+</li>
          </ul>
        </div>
        <button 
          onclick="location.reload()" 
          style="
            margin-top: 30px; 
            padding: 10px 20px; 
            background-color: #1976d2; 
            color: white; 
            border: none; 
            border-radius: 4px; 
            cursor: pointer;
            font-size: 16px;
          "
        >
          Tentar Novamente
        </button>
      </div>
    `;
  }
};

export { checkBrowserSupport, showUnsupportedBrowserMessage };
